import React from 'react';
import ReactDOM from 'react-dom';
import FavoriteButton from './favorite-button/button'

export default function (mountPoint) {
	ReactDOM.render(<FavoriteButton
		mountPoint={mountPoint}
		endpointAdd={mountPoint.dataset.endpointAdd}
		endpointRemove={mountPoint.dataset.endpointRemove}
		titleAdd={mountPoint.dataset.titleAdd}
		titleRemove={mountPoint.dataset.titleRemove}
		active={mountPoint.dataset.active}
	/>, mountPoint);
}
